import Application from '@ember/application';
import {
  importSync,
  isDevelopingApp,
  isTesting,
  macroCondition,
} from '@embroider/macros';

import * as Sentry from '@sentry/ember';
import { setBuildURLConfig } from '@warp-drive/utilities';
import { irregular } from '@warp-drive/utilities/string';
import { extendResolver } from 'ember-can';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import flatpickr from 'flatpickr';
import lang from 'flatpickr/dist/l10n';

import '@warp-drive/ember/install';
import 'ember-power-select/styles';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_green.css';

import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';

import config from 'umg-ember-backend/config/environment';

import './assets/styles/app.css';

flatpickr.localize(lang.de);
irregular('taxon', 'taxa');

setBuildURLConfig({
  host: config.API.host,
  namespace: config.API.namespace,
});

// Only use sentry exception logging in staging and production
if (macroCondition(!isDevelopingApp() && !isTesting())) {
  Sentry.init({
    dsn: 'https://f6c8998410ad0b48484ff7da7e92c6c6@o4506060448268288.ingest.us.sentry.io/4509241689243648',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

if (macroCondition(isDevelopingApp())) {
  importSync('./deprecation-workflow.js');
}

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = extendResolver(Resolver);

  // setup inspector for this application
  inspector = setupInspector(this);
}

loadInitializers(App, config.modulePrefix);
